import React, { useEffect, useState } from 'react';
import ThemeLibrary from './ThemeLibrary';
import GameLibrary from './GameLibrary';
import { getAgentCredentials, agentPackageUrl, regenerateAgentToken, getAgentMode, setAgentMode, type AgentCredentials } from './api';

interface Props { isAdmin: boolean; canManageThemes?: boolean; isMobile?: boolean; streamerId?: number; }
type Tab = 'themes' | 'jeux';

export default function LivesInteractifs({ isAdmin, canManageThemes, isMobile, streamerId }: Props) {
  const [tab, setTab] = useState<Tab>('themes');
  const [showAgent, setShowAgent] = useState(false);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', background: '#f8fafc' }}>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', flexShrink: 0 }}>
        <div style={{ padding: isMobile ? '16px 16px 0' : '24px 32px 0' }}>
          {!isMobile && (
            <div style={{ marginBottom: 16, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
              <div>
                <h1 style={{ margin: 0, color: '#0f172a', fontSize: 22, fontWeight: 700 }}>Lives interactifs</h1>
                <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 14 }}>Gérez les thèmes et les jeux interactifs</p>
              </div>
              {streamerId && (
                <button onClick={() => setShowAgent(true)}
                  style={{ flexShrink: 0, padding: '8px 14px', borderRadius: 8, border: '1px solid #c7d2fe', background: '#eef2ff', color: '#4338ca', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  💻 Agent PC (Jeux)
                </button>
              )}
            </div>
          )}
          {isMobile && (
            <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
              <h1 style={{ margin: 0, color: '#0f172a', fontSize: 18, fontWeight: 700 }}>Lives interactifs</h1>
              {streamerId && (
                <button onClick={() => setShowAgent(true)}
                  style={{ flexShrink: 0, padding: '7px 11px', borderRadius: 8, border: '1px solid #c7d2fe', background: '#eef2ff', color: '#4338ca', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  💻 Agent PC
                </button>
              )}
            </div>
          )}
          {!isMobile && (
            <div style={{ display: 'flex' }}>
              <TabBtn active={tab === 'themes'} onClick={() => setTab('themes')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}><path strokeLinecap="round" strokeLinejoin="round" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" /></svg>
                Thèmes
              </TabBtn>
              <TabBtn active={tab === 'jeux'} onClick={() => setTab('jeux')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}><path strokeLinecap="round" strokeLinejoin="round" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" /></svg>
                Jeux
              </TabBtn>
            </div>
          )}
        </div>
      </div>
      <div style={{ flex: 1, overflow: 'hidden', paddingBottom: isMobile ? 58 : 0 }}>
        {tab === 'themes' && <ThemeLibrary isAdmin={canManageThemes ?? isAdmin} isMobile={isMobile} />}
        {tab === 'jeux' && <GameLibrary isAdmin={isAdmin} isMobile={isMobile} />}
      </div>
      {showAgent && streamerId && (
        <AgentPanel streamerId={streamerId} isMobile={isMobile} onClose={() => setShowAgent(false)} />
      )}
      {isMobile && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100, background: '#fff', borderTop: '1px solid #e2e8f0', display: 'flex', alignItems: 'stretch', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
          <button onClick={() => setTab('themes')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: tab === 'themes' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${tab === 'themes' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" /></svg>
            <span style={{ fontSize: 10, fontWeight: tab === 'themes' ? 600 : 400 }}>Thèmes</span>
          </button>
          <button onClick={() => setTab('jeux')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: tab === 'jeux' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${tab === 'jeux' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" /></svg>
            <span style={{ fontSize: 10, fontWeight: tab === 'jeux' ? 600 : 400 }}>Jeux</span>
          </button>
        </div>
      )}
    </div>
  );
}

function AgentPanel({ streamerId, isMobile, onClose }: { streamerId: number; isMobile?: boolean; onClose: () => void }) {
  const [cred, setCred] = useState<AgentCredentials | null>(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [mode, setMode] = useState<string>('keyboard');

  const load = () => {
    getAgentCredentials(streamerId)
      .then(r => setCred(r.data))
      .catch(e => setErr(e?.response?.data?.detail || 'Erreur de chargement.'));
    getAgentMode(streamerId).then(r => setMode(r.data.mode)).catch(() => {});
  };
  useEffect(load, [streamerId]);

  const changeMode = async (m: string) => {
    setMode(m);
    try { await setAgentMode(streamerId, m); } catch {}
  };

  const regen = async () => {
    if (!window.confirm("Régénérer le jeton invalidera l'agent déjà installé (il faudra réinstaller). Continuer ?")) return;
    setBusy(true);
    try { await regenerateAgentToken(streamerId); load(); } catch {} finally { setBusy(false); }
  };

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center', padding: isMobile ? 0 : 16 }}>
      <div style={{ background: '#fff', borderRadius: isMobile ? '16px 16px 0 0' : 14, width: '100%', maxWidth: 520, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 24px 70px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, background: '#fff' }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>💻 Agent PC (Jeux)</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, color: '#94a3b8', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={{ margin: 0, color: '#475569', fontSize: 13.5, lineHeight: 1.6 }}>
            L'agent exécute, dans le <strong>jeu</strong> du streamer, les actions configurées
            dans « Mes Lives Interactifs » (touches clavier ou boutons manette déclenchés par les cadeaux).
            Installation en <strong>un seul fichier, un clic</strong> : télécharge l'agent, double-clique,
            c'est tout (aucun ID à saisir). Le jeu doit être la fenêtre active.
          </p>

          {err && <div style={{ color: '#dc2626', fontSize: 13 }}>{err}</div>}

          {cred && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                <span style={{ width: 9, height: 9, borderRadius: '50%', background: cred.pc_connected ? '#22c55e' : '#cbd5e1', flexShrink: 0 }} />
                <span style={{ color: cred.pc_connected ? '#16a34a' : '#64748b', fontWeight: 600 }}>
                  {cred.pc_connected ? 'PC connecté' : 'PC non connecté'}
                </span>
                <button onClick={load} style={{ marginLeft: 'auto', background: 'none', border: '1px solid #e2e8f0', borderRadius: 6, padding: '4px 10px', fontSize: 12, color: '#2563eb', cursor: 'pointer' }}>↻</button>
              </div>

              <a href={agentPackageUrl(streamerId, cred.token)}
                style={{ display: 'block', textAlign: 'center', padding: '13px', borderRadius: 10, background: '#4338ca', color: '#fff', fontSize: 15, fontWeight: 700, textDecoration: 'none' }}>
                ⬇ Télécharger l'agent (Windows)
              </a>

              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 6 }}>Mode de jeu</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {([['keyboard', '🖥️ Clavier (PC)'], ['gamepad', '🎮 Manette (Remote Play)']] as const).map(([k, label]) => (
                    <button key={k} onClick={() => changeMode(k)}
                      style={{ flex: 1, padding: '9px 6px', borderRadius: 8, border: '1px solid', borderColor: mode === k ? '#4338ca' : '#e2e8f0', background: mode === k ? '#eef2ff' : '#fff', color: mode === k ? '#4338ca' : '#64748b', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
                      {label}
                    </button>
                  ))}
                </div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 5, lineHeight: 1.4 }}>
                  Manette = pour PS / Xbox Remote Play (nécessite le pilote ViGEmBus installé une fois sur le PC).
                </div>
              </div>

              <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 4 }}>Installation manuelle (jeton)</div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 6 }}>Si besoin, colle ce jeton dans l'installeur :</div>
                <code style={{ display: 'block', wordBreak: 'break-all', fontSize: 11.5, color: '#0f172a', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 9px' }}>{cred.token}</code>
              </div>

              <button onClick={regen} disabled={busy}
                style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 12, cursor: 'pointer', textAlign: 'center' }}>
                {busy ? '…' : 'Régénérer le jeton (révoquer l\'agent installé)'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function TabBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick} style={{ padding: '10px 18px', background: 'none', border: 'none', borderBottom: `2px solid ${active ? '#2563eb' : 'transparent'}`, color: active ? '#2563eb' : '#64748b', fontSize: 13, fontWeight: active ? 600 : 400, cursor: 'pointer', display: 'flex', alignItems: 'center', transition: 'all 0.15s', marginBottom: -1 }}>
      {children}
    </button>
  );
}
